import React, { Component } from 'react';
import FileUploader from "./ImagenTexto/FileUploader";
import FileUploaderUpdate from "./ImagenTexto/FileUploaderUpdate";
import { MDBIcon, MDBInput } from 'mdbreact';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import { CargueImagenes, Conozcanos_ } from '../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';

const validate = values => {
    const errors = {}
    if (!values.nombreconozcanos) {
        errors.nombreconozcanos = 'campo obligatorio'
    }
    if (!values.txtconozcanos1) {
        errors.txtconozcanos1 = 'campo obligatorio'
    }
    if (!values.txtconozcanos2) {
        errors.txtconozcanos2 = 'campo obligatorio'
    }
    return errors;
};

class ImagenTexto extends Component {
    uploader = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            estadoNuevo: false,
            errors: {},
            estadoCambioImg1: true,
            infoConvenios: [],
            nombreconozcanos: '',
            txtconozcanos1: '',
            txtconozcanos2: '',
            editnombreconozcanos: '',
            edittxtconozcanos1: '',
            edittxtconozcanos2: '',
            estadoImagen: false,
            displayColorPicker: false,
            displayColorPicker2: false,
            rutaimgconozc: '',
            color: '#ffffff',
            colorlinea: '#ffffff',
            estadoSinInfo: false,
        };
    }

    async componentDidMount() {
        this.cargarInformacion();
    }

    cargarInformacion = () => {
        const data = {
            tran: 4,
            idvtaconozcanos: 0,
            nombreconozcanos: 'NA',
            rutaimgconozc: 'NA',
            txtconozcanos1: 'NA',
            txtconozcanos2: 'NA',
            colortexto: 'NA',
            colorlinea: 'NA',
            estado: 0,
            usucrea: 'NA'
        }
        Conozcanos_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (!response.data[0].message) {
                        this.setState({
                            idSeleccionado: response.data[0].idvtaconozcanos
                        })
                        setTimeout(() => {
                            this.setState({
                                infoConvenios: response.data,
                                editnombreconozcanos: response.data[0].nombreconozcanos,
                                rutaimgconozc: response.data[0].rutaimgconozc,
                                edittxtconozcanos1: response.data[0].txtconozcanos1,
                                edittxtconozcanos2: response.data[0].txtconozcanos2,
                                edittxtslider3: response.data[0].txtslider3,
                                color: response.data[0].colortexto,
                                colorlinea: response.data[0].colorlinea,
                                estado: response.data[0].estado,
                                estadoSinInfo: true,
                                estadoImagen: true,
                            })
                            document.getElementById('' + response.data[0].idvtaconozcanos + '').style.background = "#f47216";
                            document.getElementById('' + response.data[0].idvtaconozcanos + '').style.color = "#fff";
                            document.getElementById('' + response.data[0].idvtaconozcanos + '').style.fontWeight = "bold";
                        }, 120);
                    } else {
                        this.setState({
                            estadoSinResultados: false,
                            estadoNuevo: true,
                            estadoCambioImg1: true,
                            estadoSinInfo: false
                        })
                    }
                } else { }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    text: 'Ocurrio un error al consumir el servicio, comuniquese con sistemas!'
                })
            }
        });
    }

    textInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    cambioImagen1 = (name, file) => {
        this.setState({
            estadoCambioImg1: true
        });
    }

    cambioImagen = (name, file) => {
        this.setState({
            estadoCambioImg: true
        });
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleChange = (color) => {
        this.setState({ color: color.hex })
    };

    handleClick2 = () => {
        this.setState({ displayColorPicker2: !this.state.displayColorPicker2 })
    };

    handleClose2 = () => {
        this.setState({ displayColorPicker2: false })
    };

    handleChange2 = (color) => {
        this.setState({ colorlinea: color.hex })
    };

    cargarImagen = () => {
        var formData = new FormData();
        if (undefined === this.uploader.current) return;
        formData.append("file", this.uploader.current.getFileObject());
        formData.append("rutaImagen", '/Conozcanos/ImagenTexto/' + this.uploader.current.getFileName());
        CargueImagenes(formData).then(response => {
            if (response) {
                this.cargarInformacion();
            }
        });
    }

    insertarDatos = () => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });
        if (!Object.keys(result).length) {
            // formulario validado
            const data = {
                tran: 1,
                idvtaconozcanos: 0,
                nombreconozcanos: this.state.nombreconozcanos,
                rutaimgconozc: '/Conozcanos/ImagenTexto/' + this.uploader.current.getFileName(),
                txtconozcanos1: this.state.txtconozcanos1,
                txtconozcanos2: this.state.txtconozcanos2,
                colortexto: this.state.color,
                colorlinea: this.state.colorlinea,
                estado: 1,
                usucrea: sessionStorage.getItem('idusuario')
            }
            Conozcanos_(data).then(response => {
                if (response.data.length > 0) {
                    if (response.data[0].message === "000000") {
                        this.cargarImagen();
                        Swal.fire({
                            icon: 'success',
                            title: 'Se agrego correctamente.'
                        })
                        this.setState({
                            estadoNuevo: false,
                            nombreconozcanos: '',
                            txtconozcanos1: '',
                            txtconozcanos2: '',
                            estadoImagen: false,
                            displayColorPicker: false,
                            rutafondoImg: '',
                            color: '',
                            colorlinea: '',
                        })
                        this.cargarInformacion();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al insertar.'
                        })
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error!'
                    })
                }
            });
        }
    }

    busquedaId = (id) => {
        document.getElementById('' + this.state.idSeleccionado + '').style.background = "#fff";
        document.getElementById('' + this.state.idSeleccionado + '').style.color = "#000";
        document.getElementById('' + this.state.idSeleccionado + '').style.fontWeight = "normal";
        document.getElementById('' + id + '').style.background = "#f47216";
        document.getElementById('' + id + '').style.color = "#fff";
        document.getElementById('' + id + '').style.fontWeight = "bold";
        this.setState({
            estadoCambioImg: false,
            est: !this.state.est,
            idSeleccionado: id
        })
        const data = {
            tran: 5,
            idvtaconozcanos: id,
            nombreconozcanos: 'NA',
            rutaimgconozc: 'NA',
            txtconozcanos1: 'NA',
            txtconozcanos2: 'NA',
            txtslider3: 'NA',
            colortexto: 'NA',
            colorlinea: 'NA',
            estado: this.state.estado,
            usucrea: 'NA'
        }
        Conozcanos_(data).then(response => {
            if (response.data.length > 0) {
                this.setState({
                    editnombreconozcanos: response.data[0].nombreconozcanos,
                    rutaimgconozc: response.data[0].rutaimgconozc,
                    edittxtconozcanos1: response.data[0].txtconozcanos1,
                    edittxtconozcanos2: response.data[0].txtconozcanos2,
                    edittxtslider3: response.data[0].txtslider3,
                    color: response.data[0].colortexto,
                    colorlinea: response.data[0].colorlinea,
                    estado: response.data[0].estado,
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'No hay información'
                })
            }
        });
    }

    activar = (id) => {
        const data = {
            tran: 6,
            idvtaconozcanos: id,
            nombreconozcanos: 'NA',
            rutaimgconozc: 'NA',
            txtconozcanos1: 'NA',
            txtconozcanos2: 'NA',
            txtslider3: 'NA',
            colortexto: 'NA',
            colorlinea: 'NA',
            estado: 1,
            usucrea: sessionStorage.getItem('idusuario')
        }
        Conozcanos_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se activo satisfactoriamente'
                });
                document.getElementById('' + this.state.idSeleccionado + '').style.background = "#fff";
                document.getElementById('' + this.state.idSeleccionado + '').style.color = "#000";
                document.getElementById('' + this.state.idSeleccionado + '').style.fontWeight = "normal";
                this.cargarInformacion();
            }
        });
    }

    actualizarDatos = (id) => {
        var ruta = '';
        var capNombre = this.uploader.current.getFileName();
        if (capNombre === undefined || capNombre === null) {
            ruta = this.state.rutaimgconozc;
        } else {
            ruta = '/Conozcanos/ImagenTexto/' + this.uploader.current.getFileName();
        }
        const data = {
            tran: 1,
            idvtaconozcanos: id,
            nombreconozcanos: this.state.editnombreconozcanos,
            rutaimgconozc: ruta,
            txtconozcanos1: this.state.edittxtconozcanos1,
            txtconozcanos2: this.state.edittxtconozcanos2,
            colortexto: this.state.color,
            colorlinea: this.state.colorlinea,
            estado: 1,
            usucrea: sessionStorage.getItem('idusuario')
        }
        Conozcanos_(data).then(response => {
            if (response.data.length > 0) {
                if (response.data[0].message === "000000") {
                    this.cargarImagen();
                    this.setState({
                        estadoCambio: false,
                        estadoEditar: false,
                    })
                    Swal.fire({
                        icon: 'success',
                        title: 'Se actualizo satisfactoriamente'
                    })
                    document.getElementById('' + this.state.idSeleccionado + '').style.background = "#fff";
                    document.getElementById('' + this.state.idSeleccionado + '').style.color = "#000";
                    document.getElementById('' + this.state.idSeleccionado + '').style.fontWeight = "normal";
                    this.cargarInformacion();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error al actualizar'
                    })
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrio un error!'
                })
            }
        });
    }

    handleNew = () => {
        this.setState({
            estadoNuevo: !this.state.estadoNuevo,
            color: '#ffffff',
            colorlinea: '#ffffff',
            errors: {}
        })
        if (this.state.estadoNuevo) {
            this.setState({
                color: '#ffffff',
                colorlinea: '#ffffff',
                errors: {}
            })
            this.cargarInformacion();
        }
    }

    render() {
        const { estadoNuevo, infoConvenios, nombreconozcanos, estadoCambioImg1, estadoCambioImg, errors, estadoSinInfo, txtconozcanos1, txtconozcanos2, estadoImagen, rutaimgconozc } = this.state;
        const styles = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: this.state.color
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        const colorLinea = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: this.state.colorlinea,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <React.Fragment>
                <p>Imagen - Texto Conozcanos </p>
                <hr />
                {estadoSinInfo ? (
                    <React.Fragment>
                        <div className="plus_add_agencia align-items-center d-flex" onClick={() => { this.handleNew() }}>
                            {estadoNuevo ? <p>Cancelar &nbsp;<MDBIcon icon="times" size="lg" /></p> : <p>Agregar Nuevo &nbsp;<MDBIcon icon="plus-circle" size="lg" /></p>}
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment></React.Fragment>
                )}
                {estadoNuevo ? (
                    <React.Fragment>
                        <div className="justify-content-center d-flex">
                            <div className="text-center">
                                <FileUploader ref={this.uploader} estadoImg={estadoCambioImg1} FCambiar={this.cambioImagen1} />
                            </div>
                        </div>
                        <div className="container mt-5 pt-5 pb-5">
                            <div className="row">
                                <div className="col-md-4">
                                    <MDBInput label="Nombre" type="text" name="nombreconozcanos" value={nombreconozcanos} onChange={this.textInput} />
                                    {errors.nombreconozcanos && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.nombreconozcanos}</strong>}
                                </div>
                                <div className="col-md-4">
                                    <MDBInput label="Texto 1" type="text" name="txtconozcanos1" value={txtconozcanos1} onChange={this.textInput} />
                                    {errors.txtconozcanos1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.txtconozcanos1}</strong>}
                                </div>
                                <div className="col-md-4">
                                    <MDBInput label="Texto 2" type="text" name="txtconozcanos2" value={txtconozcanos2} onChange={this.textInput} />
                                    {errors.txtconozcanos2 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.txtconozcanos2}</strong>}
                                </div>
                                <div className="col-md-6 mt-3">
                                    <p>Color Texto</p>
                                    <div style={styles.swatch} onClick={this.handleClick}>
                                        <div style={styles.color} />
                                    </div>
                                    {this.state.displayColorPicker ? <div style={styles.popover}>
                                        <div style={styles.cover} onClick={this.handleClose} />
                                        <SketchPicker color={this.state.color} onChange={this.handleChange} />
                                    </div> : null}
                                </div>
                                <div className="col-md-6 mt-3">
                                    <p>Color Linea</p>
                                    <div style={colorLinea.swatch} onClick={this.handleClick2}>
                                        <div style={colorLinea.color} />
                                    </div>
                                    {this.state.displayColorPicker2 ? <div style={colorLinea.popover}>
                                        <div style={colorLinea.cover} onClick={this.handleClose2} />
                                        <SketchPicker color={this.state.colorlinea} onChange={this.handleChange2} />
                                    </div> : null}
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="button" className="btn btn-primary px-5" onClick={this.insertarDatos}>Guardar nuevo &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="listado_banner pt-5">
                            <p>Seleccionar banner</p>
                            <ul>
                                {infoConvenios.map((e, i) => {
                                    let view;
                                    if (e.estado === 1) {
                                        view = <MDBIcon icon="eye" size="lg" style={{ color: 'black', position: 'absolute', right: '-38px', marginTop: '5px' }} />
                                    } else {
                                        view = <MDBIcon onClick={() => { this.activar(e.idvtaconozcanos) }} icon="eye-slash" size="lg" style={{ color: 'black', position: 'absolute', right: '-38px', marginTop: '5px' }} />
                                    }
                                    return [
                                        <li key={i} id={e.idvtaconozcanos} onClick={() => { this.busquedaId(e.idvtaconozcanos) }}>{e.nombreconozcanos} {view}</li>
                                    ]
                                })}
                            </ul>
                        </div>
                        <div className="justify-content-center d-flex">
                            <div className="text-center">
                                {estadoImagen ? (
                                    <FileUploaderUpdate ref={this.uploader} ruta={rutaimgconozc} estadoImg={estadoCambioImg} FCambiar={this.cambioImagen} />
                                ) : (
                                    <React.Fragment></React.Fragment>
                                )}
                            </div>
                        </div>
                        <div className="container mt-5 pt-5 pb-5">
                            <div className="row">
                                <div className="col-md-4">
                                    <MDBInput label="Nombre" type="text" name="editnombreconozcanos" value={this.state.editnombreconozcanos} onChange={this.textInput} />
                                </div>
                                <div className="col-md-4">
                                    <MDBInput label="Texto 1" type="text" name="edittxtconozcanos1" value={this.state.edittxtconozcanos1} onChange={this.textInput} />
                                </div>
                                <div className="col-md-4">
                                    <MDBInput label="Texto 2" type="text" name="edittxtconozcanos2" value={this.state.edittxtconozcanos2} onChange={this.textInput} />
                                </div>
                                <div className="col-md-6 mt-3">
                                    <p>Color Texto</p>
                                    <div style={styles.swatch} onClick={this.handleClick}>
                                        <div style={styles.color} />
                                    </div>
                                    {this.state.displayColorPicker ? <div style={styles.popover}>
                                        <div style={styles.cover} onClick={this.handleClose} />
                                        <SketchPicker color={this.state.color} onChange={this.handleChange} />
                                    </div> : null}
                                </div>
                                <div className="col-md-6 mt-3">
                                    <p>Color Linea</p>
                                    <div style={colorLinea.swatch} onClick={this.handleClick2}>
                                        <div style={colorLinea.color} />
                                    </div>
                                    {this.state.displayColorPicker2 ? <div style={colorLinea.popover}>
                                        <div style={colorLinea.cover} onClick={this.handleClose2} />
                                        <SketchPicker color={this.state.colorlinea} onChange={this.handleChange2} />
                                    </div> : null}
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="button" className="btn btn-success px-5" onClick={() => { this.actualizarDatos(this.state.idSeleccionado) }}>Guardar cambios &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default ImagenTexto;